module.exports = __webpack_public_path__ + "img/lpf_icon.710cb244.png";